import React, { useContext, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  makeStyles,
} from "@mui/material";
import {
  createUserWithEmailAndPassword,
  getUid,
  signInWithEmailAndPassword,
} from "../../auth/user";
import { SnackbarContext } from "../../provider/SnackbarProvider";
import { GameContext } from "../../provider/GameProvider";
import { loadGame } from "../../save/saveCombiner";

interface LoginDialogProps {
  open: boolean;
  onClose: () => void;
  type: "login" | "signup";
}

const SignInSignUpDialog: React.FC<LoginDialogProps> = ({
  open,
  onClose,
  type,
}) => {
  const { showSnackbar } = useContext(SnackbarContext);
  const { setGame } = useContext(GameContext);
  const uid = getUid();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };
  const loadGameData = async () => {
    const game = await loadGame(uid);
    if (!game) return;
    setGame(game);
  };
  const handleLogin = async () => {
    const succesful = await signInWithEmailAndPassword(email, password);
    if (!succesful) {
      showSnackbar("Login failed");
      return;
    }
    onClose();
    await loadGameData();
    showSnackbar("Logged in successfully");
    window.location.reload();
  };

  const handleSignUp = async () => {
    const succesful = await createUserWithEmailAndPassword(email, password);
    if (succesful) {
      showSnackbar("Signed up successfully");
    } else {
      showSnackbar("Sign up failed");
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle style={{ color: "#2196f3" }}>
        {type === "login" ? "Login" : "Sign Up"}
      </DialogTitle>
      <DialogContent>
        <TextField
          label="Email"
          type="email"
          value={email}
          onChange={handleEmailChange}
          fullWidth
          margin="normal"
          sx={{
            color: "white",
            "& label.Mui-focused": { color: "inherit" },
            "& .MuiInput-underline:after": { borderBottomColor: "inherit" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "white" },
              "&:hover fieldset": { borderColor: "white" },
              "&.Mui-focused fieldset": { borderColor: "inherit" },
            },
          }}
          InputProps={{
            style: { color: "white", opacity: 0.8 },
          }}
          InputLabelProps={{
            style: { color: "white", opacity: 0.8 },
          }}
        />
        <TextField
          label="Password"
          type="password"
          value={password}
          onChange={handlePasswordChange}
          fullWidth
          margin="normal"
          sx={{
            color: "white",
            "& label.Mui-focused": { color: "inherit" },
            "& .MuiInput-underline:after": { borderBottomColor: "inherit" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "white" },
              "&:hover fieldset": { borderColor: "white" },
              "&.Mui-focused fieldset": { borderColor: "inherit" },
            },
          }}
          InputProps={{
            style: { color: "white", opacity: 0.8 },
          }}
          InputLabelProps={{
            style: { color: "white", opacity: 0.8 },
          }}
        />
      </DialogContent>
      <DialogActions>
        {type === "login" ? (
          <Button onClick={handleLogin} variant="contained" color="primary">
            Login
          </Button>
        ) : (
          <Button onClick={handleSignUp} variant="contained" color="secondary">
            Sign Up
          </Button>
        )}
        <Button
          onClick={() => {
            onClose();
          }}
          variant="outlined"
          color="primary"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SignInSignUpDialog;
